import { notification } from 'doraemon';
import {
  getBalanceControlConfig,
  getCostControlRule,
  getDistrictsManageList,
  // getProvinceDistrictList,
  getInstitutionList,
  // getTenantList,
  getInvoiceConfigDetail,
  getTagCombineList,
  reqAccountConfig,
  reqAccountingDetail,
  reqAccountingList,
  reqAccountingSaveOrUpdate,
  saveBalanceControlConfig,
  saveInvoiceConfig,
  setDistrictsManage,
} from '../services/index';

const responseErrorHandle = res => {
  const { success, message } = res;
  if (!success) {
    notification.error({
      message: message || '请求出错了',
    });
  }
  return success;
};

export default {
  namespace: 'tenantDetail',
  state: {},
  effects: {
    // // 获取区划管理列表
    // * getDistrictsList ({ payload }, { call }) {
    //   const res = yield call(getTenantList, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },
    // 获取区划负责人列表
    *getDistrictsManageList({ payload }, { call }) {
      const res = yield call(getDistrictsManageList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 设置区划负责人
    *setDistrictsManage({ payload }, { call }) {
      const res = yield call(setDistrictsManage, payload);
      responseErrorHandle(res);
      return res;
    },
    // // 获取省级区划
    // * getProvinceDistrictList ({ payload }, { call }) {
    //   const res = yield call(getProvinceDistrictList, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },
    // 分页查询机构下级单位列表
    *getInstitutionList({ payload }, { call }) {
      const res = yield call(getInstitutionList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 根据区划code查询费控规则
    *getCostControlRule({ payload }, { call }) {
      const res = yield call(getCostControlRule, payload);
      responseErrorHandle(res);
      return res;
    },

    // 标签联合查询
    *getTagCombineList({ payload }, { call }) {
      const res = yield call(getTagCombineList, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 核算系统枚举列表
    *getAccountingList({ payload }, { call }) {
      const res = yield call(reqAccountingList, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 获取区划下核算系统详情
    *getAccountingDetail({ payload }, { call }) {
      const res = yield call(reqAccountingDetail, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 保存更新区划下的核算系统
    *handleAccountingSaveOrUpdate({ payload }, { call }) {
      const res = yield call(reqAccountingSaveOrUpdate, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 查询是否关账
    *getAccountConfig({ payload }, { call }) {
      const res = yield call(reqAccountConfig, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 获取配置详情
    *getInvoiceConfigDetail({ payload }, { call }) {
      const res = yield call(getInvoiceConfigDetail, payload);
      return res || {};
    },
    // 保存配置
    *saveInvoiceConfig({ payload }, { call }) {
      const res = yield call(saveInvoiceConfig, payload);
      return res || {};
    },

    // 获取科目余额强弱控方式
    *getBalanceControlConfig({ payload }, { call }) {
      const res = yield call(getBalanceControlConfig, payload);
      return res || {};
    },
    // 保存科目余额强弱控方式配置
    *saveBalanceControlConfig({ payload }, { call }) {
      const res = yield call(saveBalanceControlConfig, payload);
      return res || {};
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
